import { useSelector } from 'react-redux';
import { getDisabledFeaturesList } from 'store/selectors/ui.selector';

export const isFeatureEnabled = (feature_flag: string): boolean => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const disabledFeaturesList = useSelector(getDisabledFeaturesList);

  return disabledFeaturesList.indexOf(feature_flag) === -1;
};
